import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './scaffold/App';
import * as serviceWorker from './serviceWorker';
import * as keycloak from './keycloak';

const renderApp = () => ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

keycloak.init(renderApp)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
